import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng-lts/api';

import Swal from 'sweetalert2';
import {FleetChecklistNavigationService} from '../../services/fleet-checklist-navigation.service';
import { FleetChecklistSummary, FleetStatus } from '../../models/fleet-checklist';
import { FleetChecklistListStoreService } from '../../store/fleet-checklist-list-store.service';
import {FleetChecklistEditorService} from '../../services/fleet-checklist-editor.service';

import {FleetChecklistHelper} from '../../helpers/fleet-checklist.helper';


@Component({
  selector: 'app-fleet-checklist-board',
  templateUrl: './fleet-checklist-board.component.html',
  styleUrls: ['./fleet-checklist-board.component.scss']
})
export class FleetChecklistBoardComponent implements OnInit{
  // Menu de opciones por card
  @ViewChild('contextMenu') contextMenu!: any;
  @ViewChild('popupMenu') popupMenu!: any;

  fleetsGrouped$ = this.store.fleetsGroupedByDate$;

  cardOptions: MenuItem[] = [];
  fleetSelected: FleetChecklistSummary | null = null;

  constructor(
    private navigation: FleetChecklistNavigationService,
    private store : FleetChecklistListStoreService,
    private editor : FleetChecklistEditorService
  ) { }

  ngOnInit(): void {
  }
  onOpenChecklist(checklist: FleetChecklistSummary) {
    this.navigation.openChecklist(checklist.id);
  }
  onDuplicateChecklist(checklist: FleetChecklistSummary) {
    this.editor.openToCreate(checklist);
  }
  onUpdateChecklist(checklist: FleetChecklistSummary) {
    this.editor.openToEdit(checklist);
  }
  onDeleteChecklist(checklist: FleetChecklistSummary) {
    Swal.fire({
      title: `¿Estas seguro de eliminar el grupo de validación ${checklist.name}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3b82f6',
      cancelButtonColor: '#ebebeb',
      reverseButtons: true
    }).then(async (result) => {
      if(!result.isConfirmed) return;
      console.log("elimianr", checklist)
      this.store.deleteFleet(checklist.id);
    })
  }

  getFleetType(fleetType: string): string {
    return FleetChecklistHelper.getFleetType(fleetType);
  }

  // events

  private buildMenuOptions(checklist: FleetChecklistSummary): MenuItem[] {
    const isEditable = checklist.status == FleetStatus.IN_PROGRESS; // ajusta tu condición real

    return [
      { label: 'Abrir', icon: 'pi pi-fw pi-eye', command: () => this.onOpenChecklist(checklist) },
      { label: 'Duplicar',icon: 'pi pi-fw pi-copy',command: () => this.onDuplicateChecklist(checklist) },
      ...(isEditable
        ? [{
            label: 'Modificar',
            icon: 'pi pi-fw pi-pencil',
            command: () => this.onUpdateChecklist(checklist)
          }]
        : []),

      { label: 'Eliminar', icon: 'pi pi-fw pi-trash', command: () => this.onDeleteChecklist(checklist) },
    ];
  }

  openPopupMenu(event : { event: MouseEvent, summary: FleetChecklistSummary }){
    this.fleetSelected = event.summary;
    this.cardOptions = this.buildMenuOptions(event.summary);
    this.popupMenu.toggle(event.event);
  }
  openContextMenu(event: MouseEvent, checklist: FleetChecklistSummary): void {
    event.preventDefault();
    this.popupMenu.hide();
    this.cardOptions = this.buildMenuOptions(checklist);
    this.fleetSelected = checklist;
    this.contextMenu.show(event);
  }
}
